<script>import { createEventDispatcher, getContext } from "svelte";
import { formReset } from "../../actions/formReset.js";
import FieldContainer from "./helper/FieldContainer.svelte";
import PasswordInput from "./helper/PasswordInput.svelte";
import CheckBox from "./helper/CheckBox.svelte";
import {
  createFieldContext,
  mergeStateEventDetails
} from "./helper/field.js";
export let name = void 0;
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = void 0;
export let value = void 0;
export let error = void 0;
export let disabled = false;
export let showPasswordMode = void 0;
export let control = void 0;
export const locale = void 0;
export const context = void 0;
if (showPasswordMode === void 0 && control !== void 0) {
  showPasswordMode = control.input.properties?.visible;
}
showPasswordMode = showPasswordMode ?? "last";
let internalValue = void 0;
const contextKey = createFieldContext("", value, error, disabled, value === void 0);
const ctx = getContext(contextKey);
const firstTypeContextKey = createFieldContext("", value, void 0, disabled, true);
const firstTypeCtx = getContext(firstTypeContextKey);
const retypeContextKey = createFieldContext("", "", void 0, disabled, true);
const retypeCtx = getContext(retypeContextKey);
const toggleContextKey = createFieldContext("", false, void 0, disabled, false);
const toggleCtx = getContext(toggleContextKey);
$: {
  if (value !== internalValue) {
    if (value !== "___retype-differs___" && value !== "___retype-empty___") {
      firstTypeCtx.value.set(value);
      retypeCtx.value.set(value);
    }
  }
  internalValue = value;
}
$: {
  ctx.value.set(internalValue);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(internalValue === void 0);
  firstTypeCtx.disabled.set(disabled);
  retypeCtx.disabled.set(disabled);
}
let showPassword = toggleCtx.value;
let showLast = showPasswordMode === "last";
let valueValue = firstTypeCtx.value;
let retypeValue = retypeCtx.value;
const dispatch = createEventDispatcher();
const valueChanged = (ev) => {
  $valueValue = ev.detail.value;
  updateValue();
};
const retypeChanged = (ev) => {
  $retypeValue = ev.detail.value;
  updateValue();
};
const valueStateChanged = (ev) => {
  valueStateEventDetails = ev.detail;
  updateState();
};
const retypeStateChanged = (ev) => {
  retypeStateEventDetails = ev.detail;
  updateState();
};
const updateValue = () => {
  if ($valueValue) {
    if ($retypeValue) {
      if ($valueValue === $retypeValue) {
        internalValue = $valueValue;
      } else {
        internalValue = "___retype-differs___";
      }
    } else {
      internalValue = "___retype-empty___";
    }
  } else {
    internalValue = void 0;
  }
  value = internalValue;
  dispatch("changed", {
    name,
    value: internalValue
  });
};
const updateState = () => {
  stateEventDetails = mergeStateEventDetails(valueStateEventDetails, retypeStateEventDetails);
  if (ctx)
    ctx.empty.set(stateEventDetails.state.empty);
  if (ctx)
    ctx.dirty.set(stateEventDetails.state.dirty);
  if (ctx)
    ctx.focus.set(stateEventDetails.state.focus);
  if (ctx)
    ctx.visited.set(stateEventDetails.state.visited);
  if (Object.keys(stateEventDetails.changes).length > 0) {
    dispatch("state", stateEventDetails);
  }
};
let valueStateEventDetails;
let retypeStateEventDetails;
let stateEventDetails;
let labels = label.split(":");
let callToInputs = callToInput ? callToInput.split(":") : [void 0];
let assistTexts = assistText ? assistText.split(":") : [void 0];
$:
  props = {
    label: labels[0],
    callToInput: callToInputs[0],
    assistText: assistTexts[0],
    story,
    contextKey
  };
$:
  retypeProps = {
    label: labels[labels.length > 1 ? 1 : 0],
    callToInput: callToInputs[callToInputs.length > 1 ? 1 : 0],
    assistText: assistTexts[assistTexts.length > 1 ? 1 : 0],
    story,
    contextKey
  };
</script>

<input name={name ? name : ''} use:formReset type="hidden" bind:value />
<FieldContainer {...props}>
	<svelte:fragment slot="input">
		<PasswordInput
			showPassword={$showPassword}
			{showLast}
			contextKey={firstTypeContextKey}
			on:changed={valueChanged}
			on:state={valueStateChanged}
		/>
	</svelte:fragment>
	<svelte:fragment slot="rest">
		{#if showPasswordMode !== 'never'}<CheckBox
				story="iconToggle.eyes"
				contextKey={toggleContextKey}
			/>{/if}
	</svelte:fragment>
</FieldContainer>
<FieldContainer {...retypeProps}>
	<svelte:fragment slot="input">
		<PasswordInput
			showPassword={$showPassword}
			{showLast}
			contextKey={retypeContextKey}
			on:changed={retypeChanged}
			on:state={retypeStateChanged}
		/>
	</svelte:fragment>
</FieldContainer>
